<template v-once>
  <div class="country-popup">
    <h4 class="country-popup__heading">
      {{ display }}
    </h4>
    <p class="country-popup__text" v-if="text">
      {{ text }}
    </p>
    <div v-else class="p-3">
      There is no data for this country
    </div>
    <div class="country-popup__body">
      <div v-if="variables.length > 0">
        <dl class="row mb-0">
          <template v-for="variable in variables">
            <dt class="col-sm-6 text-sm-right text-nowrap">{{ getVariable(variable).label }}</dt>
            <dd class="col-sm-6">{{ data[variable] }}</dd>
          </template>
        </dl>
        <div class="row country-popup__body__nav with-tip">
          <button class="btn btn-primary col" v-if="previous !== null" @click.prevent="openCountryPopup(previous.iso3)">
            <span class="sr-only">Previous country</span>
            <i class="fa fa-angle-left"></i>
          </button>
          <button class="btn btn-primary col" v-if="next !== null" @click.prevent="openCountryPopup(next.iso3)">
            <span class="sr-only">Next country</span>
            <i class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SETTINGS from '@/utils/settings.js'
  import taxTreaties from '@/utils/tax-treaties.js'
  import _reject from 'lodash/reject'

  export default {
    name: 'CountryPopup',
    props: ['iso3', 'name'],
    computed: {
      color () {
        return taxTreaties.color(this.iso3)
      },
      data () {
        return taxTreaties.data(this.iso3) || {}
      },
      display () {
        return this.data.country || this.name
      },
      text () {
        return taxTreaties.text(this.iso3)
      },
      variables () {
        return _reject(taxTreaties.VARIABLES, variable => {
          return !this.data[variable] || this.data[variable] === ''
        })
      },
      previous () {
        return taxTreaties.previousOf(this.iso3)
      },
      next () {
        return taxTreaties.nextOf(this.iso3)
      },
      status () {
        return taxTreaties.data['tax-treaty-status']
      }
    },
    methods: {
      getVariable (key) {
        return SETTINGS.variables[key]
      },
      openCountryPopup (iso3) {
        taxTreaties.bus.$emit('open-country-popup', iso3)
      }
    }
  }
</script>

<style lang="scss">
  .country-popup {
    font-family: $font-family-base;
    font-size: 1rem;
    width: 330px;

    @include media-breakpoint-down(xs) {
      font-size: 0.9rem;
      width: 80vw;
    }

    &__heading {
      font-size: 1.2em;
      background: darken(theme-color('cuttysark'), 15%);
      padding: $spacer;
      margin:0;
      text-transform: uppercase;
      font-style: normal;

      @include media-breakpoint-down(xs) {
        padding: $spacer / 2;
      }
    }

    & &__text, & &__body {
      padding: $spacer / 2 $spacer 0;

      @include media-breakpoint-down(xs) {
        //margin: 0;
      }
    }

    & &__text {
      padding-top:0;
    }

    &__body {

      &__nav {
        background: lighten(theme-color('cuttysark'), 5%);
        margin-top: $spacer;
        border-top: darken(theme-color('cuttysark'), 5%) 1px solid;
        position: relative;

        button {
          position: relative;
          z-index: 110;
          border:0;
          border-radius:0;
          background: inherit;
          &:hover, &:focus,&:active{
            background: inherit;
            color: white;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CountryPopup.vue?b3dd682a